import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '../../material/material.module';
import { CustomDropdownModule } from '../custom-dropdown/custom-dropdown.module';
import { GenerateEmissionReportComponent } from './generate-emission-report.component';
import { EmissionReportResultsComponent } from './emission-report-results/emission-report-results.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { CustomDatePickerModule } from '../custom-date-picker/custom-date-picker.module';
import { CustomInputModule } from '../custom-input/custom-input.module';
import { CustomTimpickerModule } from '../custom-timpicker/custom-timpicker.module';
import { ExpansionPanelModule } from '../expansion-panel/expansion-panel.module';



@NgModule({
  declarations: [GenerateEmissionReportComponent, EmissionReportResultsComponent],
  imports: [
    CommonModule,
    MaterialModule,
               FormsModule,
               ReactiveFormsModule,
               CustomDropdownModule,
               CustomDatePickerModule,
               MaterialModule,
               CustomTimpickerModule,
               CustomInputModule,
               MatPaginatorModule,
               MatIconModule,
               MatTableModule,
               MatSortModule,
               ExpansionPanelModule
  ],
    exports: [
      GenerateEmissionReportComponent,
  
      
  
    ]
})
export class GenerateEmissionReportModule { }
